














// @ is an alias to /src

import Vue from "vue";
import Background from "@/components/Background.vue";
import Language from "@/components/Language.vue";
export default Vue.extend({ components: { Background, Language } });
